import React from 'react';

import {
    Table,
    Card,
} from 'antd';

import {
    _getEnterpriseSalesAgentData
} from '../../../services'

class EnterpriseSalesAgentOverview extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            data: [],
            loading: true
        }
    }

    render() {
        return (
            <Card>
                {this.renderSalesAgentTable()}
            </Card>
        )
    }

    componentDidMount() {
        _getEnterpriseSalesAgentData()
        .then(res => {
            this.setState({
                data: res.data,
                loading: false
            })
        })
    }

    renderSalesAgentTable = () => {
        const { data } = this.state

        const columns = [{
            title: 'Sales Agent',
            dataIndex: 'agentEmail'
        },{
            title: 'Num. Enterprises',
            key: 'numEnterprises',
            render: (numEnterprises,record) => record.data.length
        },{
            title: 'Total GMV',
            key: 'totalGMV',
            render: (totalGMV,record) => this.calculateTotalGMV(record)
        },{
            title: 'Total GMV (Last Month)',
            key: 'totalGMV_lastMonth',
            render: (totalGMV,record) => this.calculateTotalGMV(record, true)
        }]

        return <Table
            loading={this.state.loading}
            columns={columns}
            pagination={false}
            dataSource={data}
            expandedRowRender={this.renderNestedTable}
        />

    }

    renderNestedTable = ( record, i ) => { 

        var columns = [{
            title: 'Logo',
            dataIndex: 'logoUrl',
            render: (logoUrl, record) => (
                <img 
                src={record.enterprise.logoUrl}
                style={{ height: 35, maxWidth: 100 }}/>
            )
        },{
            title: "Enterprise",
            dataIndex: "companyName",
            render: (companyName, record) => record.enterprise.companyName
        },{
            title: "Order",
            dataIndex: "orders",
            render: (orders, record) => record.overviewData.count || 0
        },{
            title: "GMV",
            dataIndex: "GMV",
            render: (GMV, record) => record.overviewData.amount || 0
        },{
            title: "GMV Last Month",
            dataIndex: "GMV_lastMonth",
            render: (GMV, record) => record.overviewData_lastMonth.amount || 0
        }]

        return <Table
            columns={columns}
            pagination={false}
            dataSource={record.data}
        />
    }

    calculateTotalGMV = ( record, forLastMonth ) => {

        var totalGMV = record.data.reduce((acc,cur) => {
            acc += cur[forLastMonth ? 'overviewData_lastMonth' : 'overviewData'].amount
            return acc
        },0 )
        return totalGMV
    }

}

export default EnterpriseSalesAgentOverview;


// WEBPACK FOOTER //
// ./src/components/enterprise/sales-agent/index.js